import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type WorkShiftReminderState = {
  date: string | null;
};

const initialState: WorkShiftReminderState = {
  date: null,
};

export const workShiftReminderSlice = createSlice({
  name: 'work_shift_reminder',
  initialState,
  reducers: {
    openReminder(state, action: PayloadAction<string>) {
      state.date = action.payload;
    },
    closeReminder(state) {
      state.date = null;
    },
  },
});

export const { reducer: workShiftReminderReducer, actions: workShiftReminderActions } = workShiftReminderSlice;
